module.exports = __webpack_public_path__ + "static/media/draw_02.a23106ac.gif";